export default __webpack_public_path__ + "static/media/img5.cd912823.jpg";